import React, { useEffect, useCallback, useContext, useState } from 'react';
import Card from 'components/inputs/Card';
import { useLocation } from 'react-router-dom';
import LayoutContainer from 'components/layout/LayoutContainer';
import AdminHeader from 'components/header/index';
// import DummyImage from 'assets/images/icons/dummyImage.png';
// import Avatar from 'components/inputs/Avatar';
import Button from 'components/inputs/Button';
import Profile from './Profile';
import { useDispatch, useSelector } from 'react-redux';
import ChangePassword from './ChangePassword';
// import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { GET_PROFILE } from 'actions/profile';
import _ from 'lodash';
import { GET_CHANGE_PASSWORD, MANAGE_CHANGE_PASSWORD, MANAGE_MY_PROFILE } from 'components/common/constant';
import { Spinner } from 'react-bootstrap';
// import ProfilePicInput from 'components/inputs/ProfilePicInput';
import { useTranslation } from 'react-i18next';
import Footer from 'components/general/Footer';
import { NavContext } from 'components/privateRoute/PrivateRoute';
import * as Yup from 'yup';
import { MdClose } from 'react-icons/md';
import { Form, Formik, FieldArray, getIn } from 'formik';
import { Col, Row, Modal } from 'react-bootstrap';
import TextInput from 'components/inputs/Input';
import { BiPlus, BiTrash } from 'react-icons/bi';
import { AiOutlineUser } from 'react-icons/ai';
import { toast } from 'react-toastify';
import { UPDATE_USER_GST } from 'actions/user';

const Setting = () => {
  // const history = useHistory();
  const { navigateTo } = useContext(NavContext);
  const location = useLocation();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const profileDetail = useSelector((state) => state.profile.userProfile);
  const isLoader = useSelector((state) => state.profile.isLoading);
  const rolePermissionData = useSelector((state) => state.manageRole.manageRoles);
  const currentUserName = _.get(profileDetail, 'name', '');
  const currentUserRole = _.get(profileDetail, 'role', '');
  const [showUpdateGstForm, setShowUpdateGstForm] = useState(false);

  const getProfile = useCallback(() => {
    dispatch({ type: GET_PROFILE.REQUEST });
  }, []);

  useEffect(() => {
    getProfile();
  }, []);

  const { tab } = queryString.parse(location.search);

  const setTab = (e, tab) => {
    e.preventDefault();
    navigateTo(`/setting?tab=${tab}`);
  };

  useEffect(() => {
    if (!tab) {
      navigateTo('/setting?tab=profile');
    }
  }, [tab]);

  const changePasswordPermissions =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === GET_CHANGE_PASSWORD || item.name === MANAGE_CHANGE_PASSWORD),
      (data) => data.name
    );

  const manageProfile =
    !_.isEmpty(rolePermissionData) &&
    _.map(
      _.filter(rolePermissionData[0].permissions, (item) => item.name === MANAGE_MY_PROFILE),
      (data) => data.name
    );

  const handleClose = () => {
    setShowUpdateGstForm(false);
  };

  const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  const updateUserGst = useCallback(
    (data) => {
      const gstArray = data.customer_gst_array || [];
      const gstinList = gstArray.map((item) => item.gstin.trim());

      const errors = [];

      const seen = new Set();
      const duplicates = gstinList.filter((gstin) => {
        if (seen.has(gstin)) return true;
        seen.add(gstin);
        return false;
      });
      if (duplicates.length > 0) {
        errors.push('Duplicate GSTINs found');
      }

      const invalidGstins = gstinList.filter((gstin) => !GSTIN_REGEX.test(gstin));
      if (invalidGstins.length > 0) {
        errors.push('Invalid GSTIN format');
      }

      if (errors.length > 0) {
        toast.error(errors.join(' and ') + '.');
        return;
      }

      dispatch({
        type: UPDATE_USER_GST.REQUEST,
        payload: { ...data },
        cb: (res) => {
          if (_.get(res, 'status') === 200) {
            toast.success('GSTIN updated successfully');
            setShowUpdateGstForm(false);
            setTimeout(() => {
              getProfile();
            }, 1000);
          }
        },
      });
    },
    [dispatch]
  );

  const initialValues = !_.isEmpty(profileDetail?.customer_gst_array)
    ? {
        customer_gst_array: _.map(profileDetail.customer_gst_array, (item) => {
          return {
            gstin: item.gstin,
          };
        }),
      }
    : {
        customer_gst_array: [
          {
            gstin: '',
          },
        ],
      };

  const GstFormSchema = Yup.object().shape({
    customer_gst_array: Yup.array().of(
      Yup.object().shape({
        gstin: Yup.string().required(t('profile.validationGst')),
      })
    ),
  });

  return (
    <React.Fragment>
      <LayoutContainer className="layout-container-main-page">
        <AdminHeader title={t('header.settings')} />
        <div className="page-content-wrapper scrollable">
          {isLoader ? (
            <div className="setting-page__main">
              <div className="loader--block">
                <Spinner as="span" animation="border" size="lg" role="status" />
                <span className="ps-2">{t('placeHolder.loading')}</span>
              </div>
            </div>
          ) : (
            <div className="setting-page__main">
              <Card>
                <div className="profile-banner__block">
                  <div className="profile-avatar__wrapper">
                    {profileDetail.picture ? (
                      <img src={profileDetail.picture} alt="Profile" className="profile-avatar" />
                    ) : (
                      <div className="profile-avatar default-avatar-icon">
                        <AiOutlineUser />
                      </div>
                    )}
                    <div className="profile-avatar__ring"></div>
                  </div>
                  <div className="user-content">
                    <h2 className="user-name">{_.get(profileDetail, 'name', '')}</h2>
                    <span className="user-role-badge">{_.startCase(_.get(profileDetail, 'role', ''))}</span>
                  </div>
                </div>
                <div>
                  <div className="tab-block">
                    <div className="tab-nav-block">
                      <a
                        href="#"
                        className={`tab-nav__item setting-font ${tab === 'profile' ? 'active' : ''}`}
                        onClick={(e) => setTab(e, 'profile')}
                        data-content="tab-profile"
                      >
                        {t('profile.profile')}
                      </a>
                      {!_.isEmpty(changePasswordPermissions) && (
                        <a
                          href="#"
                          className={`tab-nav__item setting-font ${tab === 'changePassword' ? 'active' : ''}`}
                          onClick={(e) => setTab(e, 'changePassword')}
                          data-content="tab-changePassword"
                        >
                          {t('profile.changePassword')}
                        </a>
                      )}
                      {tab === 'profile' && !_.isEmpty(manageProfile) && (
                        <div className="tab-nav-block__right">
                          <Button onClick={() => navigateTo('/setting/profile')}>{t('button.editProfile')}</Button>
                        </div>
                      )}

                      {currentUserRole === 'fleet_owner' && (
                        <div className="tab-nav-block__right">
                          <Button
                            onClick={() => {
                              setShowUpdateGstForm(true);
                            }}
                          >
                            {t('button.updateGst')}
                          </Button>
                        </div>
                      )}
                    </div>
                    <div className="tab-content-block">
                      <div className="tab-content__item active" id="setting-tab">
                        {tab === 'profile' && <Profile />}
                        {!_.isEmpty(changePasswordPermissions) && tab === 'changePassword' && <ChangePassword />}
                      </div>
                    </div>
                  </div>
                </div>
              </Card>
            </div>
          )}
          {currentUserName === 'CZ Tenant Admin' ? null : <Footer />}
        </div>

        {showUpdateGstForm && (
          <Modal show={showUpdateGstForm} size="lg" centered>
            <div className="wallet-transaction_main">
              <Card>
                <div className="wallet-transaction-header__block">
                  <div className="wallet-transaction-name">
                    <span>{t('profile.addGst')}</span>
                  </div>
                  <div className="close-btn">
                    <MdClose size={30} color="#be210b" onClick={handleClose} />
                  </div>
                </div>
                <div className="wallet-transaction_form">
                  <Formik
                    initialValues={initialValues}
                    validationSchema={GstFormSchema}
                    onSubmit={(values, { setSubmitting }) => {
                      updateUserGst({
                        ...values,
                      });
                      setSubmitting(false);
                    }}
                  >
                    {({ values, errors, touched, handleSubmit, setFieldValue }) => (
                      <Form onSubmit={handleSubmit}>
                        <div className="vehicle-form__inner">
                          <FieldArray
                            name="customer_gst_array"
                            render={(arrayHelpers) => (
                              <>
                                <Row>
                                  {_.map(values.customer_gst_array, (field, index) => (
                                    <>
                                      <Col lg={11} md={11}>
                                        <TextInput
                                          label={t('profile.enterGst')}
                                          placeholder={t('profile.enterGst')}
                                          name="gstin"
                                          value={field.gstin || ''}
                                          onChange={(e) => setFieldValue(`customer_gst_array[${index}].gstin`, e.target.value)}
                                          error={
                                            getIn(errors, `customer_gst_array[${index}].gstin`) &&
                                            getIn(touched, `customer_gst_array[${index}].gstin`)
                                              ? getIn(errors, `customer_gst_array[${index}].gstin`)
                                              : null
                                          }
                                        />
                                      </Col>
                                      <Col xl={1} lg={1} md={1} className="d-flex align-items-center">
                                        <Button className="field--btn" onClick={() => arrayHelpers.remove(index)}>
                                          <BiTrash size={26} />
                                        </Button>
                                      </Col>
                                    </>
                                  ))}
                                </Row>
                                <Row>
                                  <Col xl={2} md={2}>
                                    <Button
                                      className="field--btn"
                                      onClick={() =>
                                        arrayHelpers.insert(values.customer_gst_array.length, {
                                          gstin: '',
                                        })
                                      }
                                    >
                                      <BiPlus size={22} className="plus--icon" />
                                      Add
                                    </Button>
                                  </Col>
                                </Row>
                              </>
                            )}
                          />
                        </div>
                        <div className="vehicle-save--btn--block" style={{ display: 'flex', justifyContent: 'flex-end' }}>
                          <Button type="submit" className="vehicle-save-btn save--btn">
                            {t('profile.gstButton')}
                          </Button>
                        </div>
                      </Form>
                    )}
                  </Formik>
                </div>
              </Card>
            </div>
          </Modal>
        )}
      </LayoutContainer>
    </React.Fragment>
  );
};
export default Setting;
